module.exports = __webpack_public_path__ + "static/media/Artboard14.5ab2ad83.png";